import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const APPSMITH_EMPLOYEE_URL =
  "https://app.appsmith.com/app/employee/page1-68a408a38440df3fa25ed62b?embed=true&hide_navigation_bar=true";

function EmployeeManagementBK() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  員工管理
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                <iframe
                  src={APPSMITH_EMPLOYEE_URL}
                  width="100%"
                  height="800px"
                  frameBorder="0"
                  title="Appsmith Employee Management"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default EmployeeManagementBK;
